import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  TeamOutlined,
  UserAddOutlined,
  QrcodeOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

const AppSidebar = ({ collapsed, userRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 根据用户角色决定显示哪些菜单项
  const getMenuItems = () => {
    const items = [
      {
        key: '/',
        icon: <DashboardOutlined />,
        label: '首页',
        onClick: () => navigate('/'),
      },
      {
        key: '/members',
        icon: <TeamOutlined />,
        label: '会员管理',
        onClick: () => navigate('/members'),
      },
    ];

    // 如果是老板或店长，才显示添加会员和二维码管理菜单
    if (['boss', 'manager'].includes(userRole)) {
      items.push(
        {
          key: '/members/add',
          icon: <UserAddOutlined />,
          label: '添加会员',
          onClick: () => navigate('/members/add'),
        },
        {
          key: '/qrcode',
          icon: <QrcodeOutlined />,
          label: '会员二维码',
          onClick: () => navigate('/qrcode'),
        }
      );
    }
    
    return items;
  };

  // 获取当前菜单选中的key
  const getSelectedKey = () => {
    if (location.pathname.startsWith('/members/add')) return '/members/add';
    if (location.pathname.startsWith('/members/edit')) return '/members';
    return location.pathname;
  };

  return (
    <Sider trigger={null} collapsible collapsed={collapsed}>
      <div className="logo">
        {!collapsed ? '会员管理系统' : '会员'}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[getSelectedKey()]}
        items={getMenuItems()}
      />
    </Sider>
  );
};

export default AppSidebar; 